var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import device from 'current-device';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { runtime } from '../../Runtime';
export class BrowserDevice {
    parent;
    currentDevice;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.currentDevice = device;
    }
    get isTouchDevice() {
        return 'ontouchstart' in window;
    }
    get browserRuntime() {
        return this.parent;
    }
    get isSmartphoneDevice() {
        // https://github.com/matthewhudson/current-device
        if (device.mobile())
            return true;
        return false;
    }
    get isSmartphone() {
        // https://github.com/matthewhudson/current-device
        if (this.isSmartphoneDevice)
            return true;
        if (this.browserRuntime.app.appMeasure.appWidthInPixel < 600)
            return true;
        if (this.browserRuntime.app.appMeasure.appHeightInPixel < 600)
            return true;
        return false;
    }
    get isTablet() {
        const ua = window.navigator.userAgent.toLowerCase(); // bug in current-device for ipad os 13.1 (21.10.2019)
        const isiPad = ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
        return device.tablet() || isiPad;
    }
    get isTabletOrSmartphone() {
        return this.isSmartphone || this.isTablet;
    }
    get isSmallHeightDevice() {
        return runtime.solidBrowserRuntime.app.appMeasure.appHeightInPixel < 700;
    }
    get isSmallWidthDevice() {
        return runtime.solidBrowserRuntime.app.appMeasure.appWidthInPixel < 700;
    }
}
__decorate([
    memoize
], BrowserDevice.prototype, "isSmartphoneDevice", null);
__decorate([
    computed
], BrowserDevice.prototype, "isSmartphone", null);
